import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GD from "../src/assets/images/icons/g-d.png";
import GL from "../src/assets/images/icons/g-l.png";
import G1 from "../src/assets/images/icons/g1.png";
import G2 from "../src/assets/images/icons/g2.png";
import G3 from "../src/assets/images/icons/g3.png";
import G4 from "../src/assets/images/icons/g4.png";
import G5 from "../src/assets/images/icons/g5.png";
import G6 from "../src/assets/images/icons/g6.png";
import axios from "./axios";
import HeaderInner from "./Components/HeaderInner";
import { useTranslation } from "react-i18next";
import SpaLoader from "./Components/Loaders/SpaLoader";
import ReactGA from "react-ga4";
import Title from "./new-components/title/Title";
import NewFooter from "./NewFooter";
import { API_URL } from "./constants/api";
import axioss from "axios";
import { ThemeContext } from "./context/ThemeContext";
import { FaQuran } from "react-icons/fa";
import { Modal } from "react-bootstrap";

function Home() {
  const { t, i18n } = useTranslation();
  const [roomNumber, setRoomNumber] = useState();
  const [color, setColor] = useState();
  const [bgColor, setbgColor] = useState();
  const [logo, setLogo] = useState();
  const [bG, setBG] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [include_feedback, setinclude_feedback] = useState(true);
  const [guest_directory, setGuest_directory] = useState([]);
  const [homeData, setHomeData] = useState();
  const [showQuranModal, setShowQuranModal] = useState(false); // new state

  const currentDate = new Date();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const daysOfWeek = [
    "SUNDAY",
    "Monday",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const lang = localStorage.getItem("lang");
  const room_number = localStorage.getItem("room_number");

  useEffect(() => {
    const el = document.getElementById("scroll");
    if (el) {
      el.scrollIntoView();
    }
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      axios
        .get(`/${room_uuid}/qr-code`, { headers: { lang: lang } })
        .then((res) => {
          if (res.data.status === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res.data.data;
            setHomeData(data);
            setbgColor(data?.header_color);
            setColor(data?.color);
            setLogo(data?.logo);
            setinclude_feedback(data?.include_feedback);
            setBG(data?.side_menu_background_image);
            setIsLoading(false);
            const numbersArray = data.room_number.match(/\d+/g).join("");
            let result = parseInt(numbersArray, 10);
            setRoomNumber(result);
          }
        });
    };
    getData();
  }, []);

  const dateMonth = homeData?.today.split(" ");

  useEffect(() => {
    const getGuestDirectory = async () => {
      axios.get(`/${room_uuid}/guest-directory`).then((res) => {
        const data = res.data.data;
        setGuest_directory(data.guest_directory);
      });
    };
    getGuestDirectory();
  }, []);

  const has_extra_services = localStorage.getItem("has_extra_services");
  const { theme } = useContext(ThemeContext);
  const baseUrl = API_URL;
  const businessType = localStorage.getItem("businessType");
  const businessName = localStorage.getItem("business_name");

  return (
    <div className={theme ? "food h_theme" : ""}>
      {theme ? (
        <Title logo={logo} />
      ) : (
        <HeaderInner logo={logo} bgColor={bgColor} color={color} />
      )}
      {isLoading ? (
        <SpaLoader />
      ) : (
        <div
          className="home-main main-home landing-panel home_page "
          style={{
            paddingTop: "70px",
            backgroundImage: `url(${bG})`,
            backgroundSize: "cover",
          }}
        >
          <div className="base-back">
            <div className="container">
              <div className="top-info">
                <div className="wrapper">
                  <div className="wrapper_container">
                    <div className="left">
                      <div className="bluer">
                        <div className="city">
                          <img src={GL} alt="" />
                          <p className="sub_title">{t("CITY OF")}</p>
                        </div>
                        <p className="main_title">
                          {t(homeData?.city)}{" "}
                          <img src={homeData?.flag} alt="" />
                        </p>
                      </div>
                    </div>
                    <div className="right">
                      <div className="bluer">
                        <div className="info_">
                          <div>
                            <img className="" src={GD} alt="" />
                            <p className="sub_title">{t(homeData?.day_name)}</p>
                          </div>
                          <p className="main_title">
                            <span className="mr-1">{t(`${dateMonth[0]}`)}</span>
                            <span>{dateMonth[1]}</span>
                            <span>{dateMonth[2]}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="box_min_container">
              {businessType !== "Hospital" && (
                <Link
                  to={theme ? `/${room_uuid}/cart` : `/${room_uuid}/Checkout`}
                  className="box_ check_box"
                  onClick={() =>
                    ReactGA.event({
                      category: "Click on Checkout in Home Menu page",
                      action: "Click",
                      value: ``,
                    })
                  }
                >
                  <img src={G1} alt="" />
                  <p className="title_">{t("Cart Checkout")}</p>
                  <p className="sub">{room_number}</p>
                </Link>
              )}

              <Link
                to={`/${room_uuid}/AboutUs`}
                className="box_"
                onClick={() =>
                  ReactGA.event({
                    category: "Click on About in Home Menu page",
                    action: "Click",
                    value: ``,
                  })
                }
              >
                <img src={G4} alt="" />
                <p className="title_">{t("About Us")}</p>
              </Link>

              <Link
                to={`/${room_uuid}/MyOrders`}
                className="box_"
                onClick={() =>
                  ReactGA.event({
                    category: "Click on My orders in Home Menu page",
                    action: "Click",
                    value: ``,
                  })
                }
              >
                <img src={G5} alt="" />
                <p className="title_">
                  {businessType === "Hospital" ? t("My Bookings") : t("Orders")}
                </p>
              </Link>

              {businessType !== "Hospital" &&
                !businessName.includes("Mubadala") &&
                has_extra_services !== "true" &&
                include_feedback && (
                  <Link
                    to={`/${room_uuid}/Feedback`}
                    className="box_"
                    onClick={() =>
                      ReactGA.event({
                        category: "Click on Send a Feedback in Home Menu page",
                        action: "Click",
                        value: ``,
                      })
                    }
                  >
                    <img src={G3} alt="" />
                    <p className="title_">
                      {t(
                        businessType === "Hotel"
                          ? !businessName.includes("Meeting") &&
                            !businessName?.toLowerCase().includes("enec")
                            ? t("Hotel Review")
                            : t("Feedback")
                          : t("Holiday Home Review")
                      )}
                    </p>
                  </Link>
                )}
              {businessName !== "TDH Hotel 11 (Kempinski Cancun)" &&
              homeData?.show_quraan ? (
                <div
                  className="box_"
                  onClick={() => {
                    setShowQuranModal(true);
                    ReactGA.event({
                      category: "Click on Quran in Home Menu page",
                      action: "Click",
                      value: ``,
                    });
                  }}
                >
                  <div style={{ marginTop: "13px", marginBottom: "13px" }}>
                    <FaQuran size={22} color="white" />
                  </div>
                  <p className="title_">{t("quran")}</p>
                </div>
              ) : null}
              {/* 
              (
                <a
                  className="box_"
                  target="_blank"
                  href="https://qiblafinder.withgoogle.com/"
                  onClick={() => {
                    ReactGA.event({
                      category: "Click on Qibla Finder in Home Menu page",
                      action: "Click",
                      value: ``,
                    });
                  }}
                >
                  <img src={G6} alt="" />
                  <p className="title_">{t("Qibla Finder")} </p>
                </a>
              ) */}

              {guest_directory.length > 0 && homeData?.show_guest_directory && (
                <Link
                  to={`/${room_uuid}/GuestDirectory`}
                  className="box_"
                  onClick={() =>
                    ReactGA.event({
                      category: "Click on GuestDirectory in Home Menu page",
                      action: "Click",
                      value: ``,
                    })
                  }
                >
                  <img src={G2} alt="" />
                  <p className="title_">{t("Guest Directory")}</p>
                </Link>
              )}
            </div>
          </div>
        </div>
      )}

      {theme && <NewFooter />}

      {/* Quran Modal */}
      <Modal
        show={showQuranModal}
        onHide={() => setShowQuranModal(false)}
        centered
        dialogClassName="custom-quran-modal "
      >
        <Modal.Body>
          <div className="d-flex flex-column px-4 py-3 mt-0">
            <p
              style={{ color: "gray", textAlign: lang == "ar" ? "rtl" : "ltr" }}
            >
              {t("please choose your language")}
            </p>
            <div
              className=" mb-3 w-100 lang-btn"
              style={{
                border: "none",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowQuranModal(false);
                window.open(
                  "https://d3l5wxnahfuscp.cloudfront.net/Maktoom-mushaf-full-small.pdf",
                  "_blank"
                );
              }}
            >
              العربية
            </div>
            <div
              className=" w-100 lang-btn"
              style={{
                border: "none",
                cursor: "pointer",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                setShowQuranModal(false);
                window.open(
                  "https://d3l5wxnahfuscp.cloudfront.net/quran-english-translation.pdf",
                  "_blank"
                );
              }}
            >
              English
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Home;
